/* ───────────────────────────────────────────────────────────────────────────
   Native NM Squad essay system — students submit college-application essays,
   Neeraj records voice + text feedback. No mentors, no Cloudinary: the voice
   note is stored as a base64 data URL on the feedback doc (Firestore).

   Collections (nm-squad project):
   - tuapEssays         one doc per submitted essay
   - tuapEssayFeedback  one+ doc per essay — Neeraj's feedback
   ─────────────────────────────────────────────────────────────────────────── */

import { db } from "./firebase";
import {
  collection, addDoc, query, where, orderBy, onSnapshot, serverTimestamp,
} from "firebase/firestore";

export const ESSAY_TYPES = [
  "CommonApp Personal Statement", "UC Personal Insight Question",
  "Why This Major", "Why This College", "Supplemental Essay",
  "Activity / Extracurricular Essay", "Community / Diversity Essay",
  "Scholarship Essay", "UK Personal Statement", "Other",
];

// Auto-stop a voice note here so it comfortably fits one Firestore doc.
export const MAX_AUDIO_SEC = 180;

function tsMs(t) {
  if (!t) return 0;
  if (t.toDate) return t.toDate().getTime();
  const d = new Date(t);
  return isNaN(d) ? 0 : d.getTime();
}

export async function addEssay(studentId, studentName, d) {
  return await addDoc(collection(db, "tuapEssays"), {
    studentId,
    studentName: studentName || "",
    college: d.college || "",
    question: d.question || "",
    type: d.type || "",
    essay: d.essay || "",
    wordLimit: d.wordLimit || "",
    wordCount: d.wordCount || 0,
    commentsForNM: d.commentsForNM || "",
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}

export function subscribeStudentEssays(studentId, cb) {
  const q = query(collection(db, "tuapEssays"), where("studentId", "==", studentId));
  return onSnapshot(q, snap => {
    const rows = snap.docs.map(d => ({ id: d.id, ...d.data() }));
    rows.sort((a, b) => tsMs(b.createdAt) - tsMs(a.createdAt));
    cb(rows);
  }, () => {});
}

export function subscribeAllEssays(cb) {
  const q = query(collection(db, "tuapEssays"), orderBy("createdAt", "desc"));
  return onSnapshot(q, snap => cb(snap.docs.map(d => ({ id: d.id, ...d.data() }))), () => {});
}

export function subscribeAllFeedback(cb) {
  return onSnapshot(collection(db, "tuapEssayFeedback"), snap => {
    const rows = snap.docs.map(d => ({ id: d.id, ...d.data() }));
    rows.sort((a, b) => tsMs(a.createdAt) - tsMs(b.createdAt));
    cb(rows);
  }, () => {});
}

// fb: { audioData, transcript, notes }
export async function addEssayFeedback(essay, fb) {
  return await addDoc(collection(db, "tuapEssayFeedback"), {
    essayId: essay.id,
    studentId: essay.studentId || "",
    audioData: fb.audioData || "",
    transcript: fb.transcript || "",
    notes: fb.notes || "",
    fromName: "Neeraj Mandhana",
    createdAt: serverTimestamp(),
  });
}
